import { createFileRoute } from '@tanstack/react-router'
import { DerivationDetailPage } from '../../../components/DerivationDetailPage'

export const Route = createFileRoute('/$org/derivations/$uid')({
  component: DerivationDetailRoute,
})

function DerivationDetailRoute() {
  return <DerivationDetailPage />
}
